export const CREATE_WORKFLOW = 'CREATE_WORKFLOW';
export const UPDATE_WORKFLOW = 'UPDATE_WORKFLOW';
export const GET_WORKFLOW = 'GET_WORKFLOW';
export const GET_WORKFLOWS = 'GET_WORKFLOWS';
export const DELETE_WORKFLOW = 'DELETE_WORKFLOW';

export const GET_FORMS = 'GET_FORMS';
export const GET_MODULES = 'GET_MODULES';
